import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-base-purple" }, "Pool Details")
], -1)
const _hoisted_2 = {
  key: 0,
  class: "rounded-br-xl h-4 w-4 flex bg-purple-500 absolute top-0 left-0 bg-opacity-80"
}
const _hoisted_3 = {
  key: 1,
  class: "px-6 py-4"
}
const _hoisted_4 = {
  key: 0,
  class: "px-6 py-4 flex items-center"
}
const _hoisted_5 = { class: "text-left font-normal text-gray-1050" }
const _hoisted_6 = { class: "px-6 py-4 -mt-1 flex justify-end font-numeric text-gray-1050" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_BalChip = _resolveComponent("BalChip")!
  const _component_LiquidityAPRTooltip = _resolveComponent("LiquidityAPRTooltip")!
  const _component_BalTable = _resolveComponent("BalTable")!

  return (_openBlock(), _createBlock(_component_BalTable, {
    columns: _ctx.columns,
    data: _ctx.filteredData,
    "is-loading": _ctx.isLoading,
    "is-loading-more": _ctx.isLoadingMore,
    "skeleton-class": "h-64",
    sticky: "both",
    square: _ctx.upToLargeBreakpoint,
    "on-row-click": _ctx.handleRowClick,
    "is-paginated": _ctx.filteredData.length < _ctx.data.length,
    "sort-externally": true,
    onLoadMore: _ctx.handleLoadMore,
    onHandleSort: _ctx.handleSort,
    "initial-state": {
      sortColumn: 'poolValue',
      sortDirection: 'desc'
    }
  }, {
    iconColumnHeader: _withCtx(() => [
      _hoisted_1
    ]),
    iconColumnCell: _withCtx((pool) => [
      (pool.farm && parseFloat(pool.shares) > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_BalAssetSet, {
              addresses: _ctx.orderedTokenAddressesFor(pool),
              width: 100
            }, null, 8, ["addresses"])
          ]))
        : _createCommentVNode("", true)
    ]),
    poolNameCell: _withCtx((pool) => [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(pool.name), 1),
            (pool.isNewPool)
              ? (_openBlock(), _createBlock(_component_BalChip, {
                  key: 0,
                  color: "red",
                  size: "sm",
                  class: "ml-2",
                  outline: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('new')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    aprCell: _withCtx((pool) => [
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(Number(pool.apr.swapApr) > 10000 ? '-' : _ctx.fNum(pool.apr.total, 'percent')) + " ", 1),
        _createVNode(_component_LiquidityAPRTooltip, { pool: pool }, null, 8, ["pool"])
      ])
    ]),
    _: 1
  }, 8, ["columns", "data", "is-loading", "is-loading-more", "square", "on-row-click", "is-paginated", "onLoadMore", "onHandleSort"]))
}